module.exports = __webpack_public_path__ + "static/media/boy3.e212917f.svg";